/**
 * The PancakeSwap pools Markets reads are those of CADINU and CBON (server/info/registry.ts discoverPancakePools). Since the PancakeSwap
 * tab is gone (2026-10-06, replaced by Smart Swap), they are reached from the CADINU and CBON token pages: the Markets token page links
 * here, and the token page (/token/0x…) lists them in its Pools tab.
 */
export const PANCAKE_COVERED_TOKENS = ['0x76e112203ef59d445452ef7556386dd2df3ed914', '0x6e64fcf15be3eb71c3d42acf44d85bb119b2d98b']

/** /info/pancakeswap/tokens/<address> for CADINU and CBON, null for every other token (no PancakeSwap coverage). */
export const pancakePoolsHref = (token: string | null | undefined): string | null => {
  const t = token?.toLowerCase()
  return t && PANCAKE_COVERED_TOKENS.includes(t) ? `/info/pancakeswap/tokens/${t}` : null
}
